
import React from 'react';

export const APP_NAME = "Lynqar";
export const DEFAULT_STORE_ID = "lynqar-gadgets-001";

export const LOGO = (
  <div className="flex items-center gap-2 font-bold text-2xl tracking-tighter">
    <span className="bg-blue-600 text-white px-2 py-0.5 rounded">L</span>
    <span className="text-gray-900">YNQAR</span>
  </div>
);
